import { render } from "./KpiRow.vue?vue&type=template&id=3a4a3254&scoped=true"
import script from "./KpiRow.vue?vue&type=script&lang=js"
export * from "./KpiRow.vue?vue&type=script&lang=js"

import "./KpiRow.vue?vue&type=style&index=0&id=3a4a3254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4a3254"]])

export default __exports__